import Typography from '@mui/material/Typography'
import { Link } from 'react-router-dom'

import CardLayout from '@/app/component/layout/card'
import ErrorLayout from '@/app/component/layout/error'
import Layout from '@/app/component/layout/page'
import { AuthHeader } from '@/app/module/auth'

export default function NotFoundPage() {
  return (
    <Layout title="Not Found - engageSPARK">
      <AuthHeader />
      <CardLayout>
        <ErrorLayout status={404}>
          <Typography>This page does not exist.</Typography>
          <Typography>
            We can help find your way back <Link to="/">home</Link>
          </Typography>
        </ErrorLayout>
      </CardLayout>
    </Layout>
  )
}
